<template>
    <div class="bg-darkBlue">
        <div v-if="!hasChildren">
            <div class="mapaMundi d-none d-lg-block">
                <div class="mapaTit" data-aos="fade-up" data-aos-duration="1500">
                    <h2 class="text-white m-auto text-center mt-5">{{ $t('mundo.roca-group-en-el-mundo') }}</h2>
                </div>
                <div class="mapaCitys">
                    <div class="mapaAmerica text-white text-start" data-aos="fade-up" data-aos-duration="1000">
                        <h3 class="text-white">{{ $t('mundo.america') }}</h3>
                    </div>
                    <div class="mapaEMEA text-white text-start" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
                        <h3 class="p-0 m-0 text-white">EMEA</h3>
                        <p v-html="$t('mundo.europa-oriente-africa')"></p>
                    </div>
                    <div class="mapaNCEE text-white text-start" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
                        <h3 class="p-0 m-0 text-white">NCEE</h3>
                        <p>{{ $t('mundo.norte-centro-y-este-de-europa') }}</p>
                    </div>
                    <div class="mapaAPAC text-white text-start" data-aos="fade-up" data-aos-delay="800" data-aos-duration="1000">
                        <h3 class="p-0 m-0 text-white">APAC</h3>
                        <p>{{ $t('mundo.asia-y-pacifico') }}</p>
                    </div>
                </div>
                <div class="elMapa">
                    <img :src="`${publicPath}img/mapaFons.jpg`" class="img-responsive">
                </div>
                <div class="mapaInfo text-start ">
                    <div class="row g-0 my-3" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" data-aos-id="counter">
                        <div class="col text-end pt-1">
                            <img :src="`${publicPath}img/mapaIcoFabrica.png`" class="img-responsive mx-3">
                        </div>
                        <div class="col-9 p-0 m-0 text-white border-bottom">
                            <h1 class="text-white">
                                <AnimatedNumber
                                    ref='counter_products_plants'
                                    :startAmount='0'
                                    :endAmount='84'
                                    :duration='3'
                                    :separator=separator
                                    :decimals='0'
                                    :autoinit='true'
                                />
                            </h1>
                            <p>{{ $t('mundo.plantas-de-produccion') }}</p>
                        </div>
                    </div>
                    <div class="row g-0 my-3" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                        <div class="col text-end pt-1">
                            <img :src="`${publicPath}img/mapaIcoLoc.png`" class="img-responsive mx-3">
                        </div>
                        <div class="col-9 p-0 m-0 text-white border-bottom">
                            <h1 class="text-white"><AnimatedNumber
                                    ref='counter_paises'
                                    :startAmount='0'
                                    :endAmount='170'
                                    :duration='3'
                                    :separator=separator
                                    :decimals='0'
                                    :autoinit='true'
                                /></h1>
                            <p>{{ $t('mundo.paises') }}</p>
                        </div>
                    </div>
                    <div class="row g-0 my-3" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                        <div class="col text-end">
                            <img :src="`${publicPath}img/mapaIcoGent.png`" class="img-responsive mx-3">
                        </div>
                        <div class="col-9 p-0 m-0 text-white">
                            <h1 class="text-white"><AnimatedNumber
                                    ref='counter_empleados'
                                    :startAmount='0'
                                    :endAmount='24492'
                                    :duration='3'
                                    :separator=separator
                                    :decimals='0'
                                    :autoinit='true'
                                /></h1>
                            <p>{{ $t('mundo.empleados') }}</p>
                        </div>
                    </div>
                </div>
            </div>
                <div class="mapaMundiPhone d-table d-lg-none" :style="{ backgroundImage: `url(${publicPath}img/mapaFonsPhone.jpg)` }">
                    <div class="mapaCitys">
                        <div class="mapaAmerica text-white text-start" data-aos="fade-up" data-aos-duration="1000">
                            <h3 class="text-white">{{ $t('mundo.america') }}</h3>
                        </div>
                        <div class="mapaEMEA text-white text-start" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
                            <h3 class="p-0 m-0 text-white">EMEA</h3>
                            <p v-html="$t('mundo.europa-oriente-africa')"></p>
                        </div>
                        <div class="mapaNCEE text-white text-start" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
                            <h3 class="p-0 m-0 text-white">NCEE</h3>
                            <p>{{ $t('mundo.norte-centro-y-este-de-europa') }}</p>
                        </div>
                        <div class="mapaAPAC text-white text-start" data-aos="fade-up" data-aos-delay="800" data-aos-duration="1000">
                            <h3 class="p-0 m-0 text-white">APAC</h3>
                            <p>{{ $t('mundo.asia-y-pacifico') }}</p>
                        </div>
                    </div>
                <h2 class="text-white m-auto text-center mt-5" v-html="$t('mundo.roca-group-en-el-mundo-phone')"></h2>
                <div class="col-7 m-auto text-center text-lg-start mapaLoc">
                    <div class="row g-0 my-3 border-bottom border-top" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1500">
                        <div class="col text-center pt-1 text-white">
                            <h1 class="text-white"><img :src="`${publicPath}img/mapaIcoFabrica.png`" class="img-responsive mx-1"> 84</h1>
                            <p>{{ $t('mundo.plantas-de-produccion') }}</p>
                        </div>
                    </div>
                    <div class="row g-0 my-3 border-bottom" data-aos="fade-left" data-aos-delay="800" data-aos-duration="1200">
                        <div class="col text-center text-white">
                            <h1 class="text-white"><img :src="`${publicPath}img/mapaIcoLoc.png`" class="img-responsive mx-1">170</h1>
                            <p>{{ $t('mundo.paises') }}</p>
                        </div>
                    </div>
                    <div class="row g-0 my-3" data-aos="fade-left" data-aos-delay="1300" data-aos-duration="1000">
                        <div class="col text-center text-white">
                            <h1 class="text-white"><img :src="`${publicPath}img/mapaIcoGent.png`" class="img-responsive mx-1"> 24.492</h1>
                            <p>{{ $t('mundo.empleados') }}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
    import AnimatedNumber from 'vue3-autocounter'
    export default {
      components: {
          AnimatedNumber
      },
      props: {
          hasChildren: Boolean
      },
      data() {
          return {
              publicPath: process.env.BASE_URL,
              separator: '.'
          }
      },
      mounted() {
        document.addEventListener('aos:in:counter', this.startCounter);
        if(this.$i18n.locale=="es"){
            this.separator = '.';
        } else {
            this.separator = ',';
        }
      },
      methods: {
        startCounter() {
          if (this.$refs.counter_products_plants != null) {
            this.$refs.counter_products_plants.start();
          }
          if (this.$refs.counter_paises != null) {
            this.$refs.counter_paises.start();
          }
          if (this.$refs.counter_empleados != null) {
            this.$refs.counter_empleados.start();
          }
        }
      }
    }
</script>
